var smart_position_iel_user_disclaimer = function(disclaimer) {
    if (document.getElementsByClassName('page-content')[0]) {
        // Get page height
        let pageHeight = window.innerHeight;

        // Get tunnel content height
        let pageContentHeight = document.getElementsByClassName('page-content')[0].getBoundingClientRect().height || 0;

        let breadcrumb = 0;
        if ($('#breadcrumbs-js')) {
            breadcrumb = $('#breadcrumbs-js').outerHeight() || 0;
        }

        let navbar = 0;
        if ($('.navbar')) {
            navbar = $('.navbar').outerHeight() || 0;
        }

        // Show 2 lines disclaimer
        let media_query = window.matchMedia("(max-width: 992px)");
        let heightTwoLines = 45;
        if (media_query.matches) {
            heightTwoLines = 120
        }

        // set margin top
        let marginTop = pageHeight - pageContentHeight - breadcrumb - navbar - heightTwoLines;

        if (pageContentHeight < pageHeight - 120) {
            if (marginTop < 1 ) {
                disclaimer.css('marginTop', '10px');
            } else {
                disclaimer.css('marginTop', String(marginTop) + 'px');
            }
        }
    }
};

window.onload = function() {
    let disclaimer = $('#iel-user-disclaimer-js');

    if (disclaimer) {
        smart_position_iel_user_disclaimer(disclaimer);

        window.addEventListener('resize', function (event) {
            smart_position_iel_user_disclaimer(disclaimer);
        });
    }
};
